import { configureStore } from '@reduxjs/toolkit'
import drawerSlice from './FormCreation/drawerSlice'
import globalSlice from './FormCreation/globalSlice'

export default configureStore({
  reducer: {
    global: globalSlice,
    drawer: drawerSlice,
  },
})
